import React, { useEffect, useContext, useState } from "react";
import Navigation from "../../Components/Navigation";
import Footer from "../../Components/Footer";
import HeroAlt from "../../Components/HeroAlt";
import { MondayContext } from "../../Contexts/MondayContext";

import Grid from "@mui/material/Grid2";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContactRibbon from "../../Components/ContactRibbon";

export default function Meetings() {
  const { meetingsData } = useContext(MondayContext);
  // console.log(meetingsData);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Meetings";
  }, []);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <main>
      <Navigation />
      <HeroAlt title='Our Meetings'/>
      <section>
        <Grid
          container
          size={12}
          justifyContent="center"
          backgroundColor='#f4f4f4'
       padding='2% 0'
          spacing={2}
        >
          {/*UPCOMING MEETINGS SECTION */}
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
            <Grid size={12}>
              <h1>Upcoming Meetings</h1>
            </Grid>
            <Grid size={12} padding="1% 0">
              <p>
                Community meetings provide an opportunity to listen to residents
                and gather valuable input and feedback on important local
                concerns and ideas. These meetings will be held in various
                locations across eastern Alachua County. Upcoming dates and
                times are currently being scheduled.{" "}
              </p>
            </Grid>
          </Grid>
          <Grid container justifyContent='center' size={{ xs: 11, sm: 11, md: 10, lg: 9, xl:9 }}>

<Grid container item size={{xs:12}} justifyContent='center'>

<Typography variant='h5' fontWeight='bold'>There are Currently No Upcoming Meetings</Typography>

</Grid>
 
          {/*   <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Community Input Session in Melrose
                  <br />
                  <strong>Date & Time : </strong>
                  May 3, 2025, 9:00 AM 
                  <br />
                  <strong>Location : </strong>
                  Melrose United Methodist Church (5807 Hampton St., Melrose, FL, 32666)
                  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>In May, the Forward Focus initiative will host a community input session in Melrose. The session will be held on Saturday, May 3, 2025, at 9 a.m. at the Melrose United Methodist Church (5807 Hampton St., Melrose, FL, 32666). All residents, businesses, and local leaders are encouraged to attend. This session will provide an opportunity to share insights and ideas about the future of Alachua County and Melrose. During this meeting, Alachua County staff will outline the project’s goals and timelines. Additionally, staff will hear attendees’ valuable feedback, which will assist in identifying development opportunities and common themes in Eastern Alachua County. 
                </Typography>
              </AccordionDetails>
            </Accordion> */}
      
      
            {/* commented out the dynamic meetins data due to backend deployment issue. */}
            {/* {meetingsData ? (
              meetingsData[0].map((item) => (
                <Accordion
                  key={item.id}
                  expanded={expanded === item.id}
                  onChange={handleChange(item.id)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${item.id}-content`}
                    id={`panel${item.id}-header`}
                  >
                    <Typography>
                      <strong>Meeting Name : </strong>
                      {item.MeetingName}
                      <br />
                      <strong>Date & Time : </strong>
                      {item.DateTime}
                      <br />
                      <strong>Location : </strong>
                      {item.Location}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2">
                      <strong>Description:</strong> {item.Description}
                    </Typography>
                    {item.Attachments.length > 0 ? (
                      <Typography variant="body2" sx={{ marginTop: 1 }}>
                        <strong>Attachments:</strong>
                        {item.Attachments.map((attachment, index) => (
                          <div key={index}>
                            <a
                              href={attachment[1]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {attachment[0]}
                            </a>
                          </div>
                        ))}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <p>Waiting for meetings data ...</p>
            )} */}
          </Grid>
        </Grid>
      </section>
      {/*PAST MEETINGS SECTION */}
      <section  >
        <Grid
          container
          size={12}
          justifyContent="center"
          backgroundColor='#f4f4f4'
          paddingTop='2%'
          paddingBottom='4%'
          spacing={2}
        >
                <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
            <Grid size={12}>
              <h1>Past Meetings</h1>
            </Grid>
          </Grid>
          <Grid container size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }}>
          <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Community Input Session in Rochelle/Windsor/Grove Park Area
                  <br />
                  <strong>Date & Time : </strong>
                  June 12, 2025, 6:00pm
                  <br />
                  <strong>Location : </strong>
                  Hall Chapel United Methodist Church (6025 SE County Road 234, Gainesville 32641)
                  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>In June, the Forward Focus initiative will host a community input session in the Rochelle/Windsor/Grove Park Area. The session will be held on Thursday, June 12th, from 6 to 8 p.m. at the Hall Chapel United Methodist Church (6025 SE County Road 234, Gainesville 32641). During the June 12th meeting, county staff will outline the project’s goals and timeline. Attendees will also have an opportunity to provide valuable feedback, which will guide the creation of a community-wide survey designed to capture the needs and aspirations of residents.  The session is open to all residents, businesses, and local leaders, providing an opportunity to share insights and ideas about the future of eastern Alachua County.
                </Typography>
              </AccordionDetails>
            </Accordion> 
          <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Community Input Session in Melrose
                  <br />
                  <strong>Date & Time : </strong>
                  May 3, 2025, 9:00 AM 
                  <br />
                  <strong>Location : </strong>
                  Melrose United Methodist Church (5807 Hampton St., Melrose, FL, 32666)
                  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>In May, the Forward Focus initiative will host a community input session in Melrose. The session will be held on Saturday, May 3, 2025, at 9 a.m. at the Melrose United Methodist Church (5807 Hampton St., Melrose, FL, 32666). All residents, businesses, and local leaders are encouraged to attend. This session will provide an opportunity to share insights and ideas about the future of Alachua County and Melrose. During this meeting, Alachua County staff will outline the project’s goals and timelines. Additionally, staff will hear attendees’ valuable feedback, which will assist in identifying development opportunities and common themes in Eastern Alachua County. 
                </Typography>
              </AccordionDetails>
            </Accordion> 
          <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Community Input Session in Island Grove/Cross Creek
                  <br />
                  <strong>Date & Time : </strong>
                  April 3, 2025, 6:00 PM
                  <br />
                  <strong>Location : </strong>
                  New Cross Creek Baptist Church (18921 S. Co Road 325, Hawthorne)
                  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>In April, the Forward Focus initiative will host a community input session in the Island Grove/Cross Creek area. The session will be held on Thursday, April 3, 2025, at 6 p.m. at the New Cross Creek Baptist Church (18921 S. Co Road 325, Hawthorne). All residents, businesses, and local leaders are encouraged to attend. This session will provide an opportunity to share insights and ideas about the future of Alachua County and Island Grove/Cross Creek. During this meeting, Alachua County staff will outline the project’s goals and timelines. Additionally, staff will hear attendees’ valuable feedback, which will assist in identifying development opportunities and common themes in Eastern Alachua County. 
                </Typography>
              </AccordionDetails>
            </Accordion>
          <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
         Monteocha Forward Focus
                  <br />
                  <strong>Date & Time : </strong>
                  March 13, 2025, 6:00 PM
                  <br />
                  <strong>Location : </strong>
                  Jerusalem Church of God by Faith Fellowship Hall (1230 NE 156th Avenue, Gainesville)
                  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>In March, the Forward Focus initiative will host a community input session in Monteocha. The session will be held on Thursday, March 13, 2025, at 6 p.m. at the Jerusalem Church of God by Faith Fellowship Hall (1230 NE 156th Avenue, Gainesville). All residents, businesses, and local leaders are encouraged to attend. This session will provide an opportunity to share insights and ideas about the future of Alachua County and Monteocha. During this meeting, county staff will outline the project’s goals and timelines. Additionally, county staff will hear attendees’ valuable feedback, which will guide the creation of a community-wide survey designed to capture the needs and aspirations of residents.
                </Typography>
              </AccordionDetails>
            </Accordion>
          <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Micanopy Forward Focus
                  <br />
                  <strong>Date & Time : </strong>
                  Feb 20, 2025, 6:00 PM
                  <br />
                  <strong>Location : </strong>
                  Micanopy Town Hall (706 NE Cholokka Blvd, Micanopy, FL 32667) 
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>The next Forward Focus community input session will be held on Thursday, Feb. 20th, at 6 p.m. at the Micanopy Town Hall (706 NE Cholokka Blvd, Micanopy). All residents, businesses, and local leaders are encouraged to attend. This session will provide an opportunity to share insights and ideas about the future of Alachua County and Micanopy. During this meeting, county staff will outline the project’s goals and timelines. Additionally, county staff will hear attendees’ valuable feedback, which will guide the creation of a community-wide survey designed to capture the needs and aspirations of residents. 
                </Typography>
              </AccordionDetails>
            </Accordion>
          <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Waldo Forward Focus
                  <br />
                  <strong>Date & Time : </strong>
                  Jan 25, 2025, 09:00 AM
                  <br />
                  <strong>Location : </strong>
                  Waldo City Square (14450 NE 148th Ave, Waldo)
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>A community input session will be
                  held on Saturday, Jan. 25th, from 9 to 12 p.m. at the Waldo
                  City Square (14450 NE 148th Ave, Waldo). The session is open
                  to all residents, businesses, and local leaders, providing an
                  opportunity to share insights and ideas about the future of
                  eastern Alachua County. During this meeting, county staff will
                  outline the project’s goals and timeline. Attendees will also
                  have an opportunity to provide valuable feedback, which will
                  guide the creation of a community-wide survey designed to
                  capture the needs and aspirations of residents.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Forward Focus: Eastern Alachua County Kicks Off Three-Year
                  Initiative
                  <br />
                  <strong>Date & Time : </strong>
                  Oct 24, 2024, 06:00 PM
                  <br />
                  <strong>Location : </strong>
                  Hawthorne Middle/High School (21403 SE 69th Ave., Hawthorne)
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>
                  The Alachua County Board of County Commissioners is pleased to
                  announce the launch of Forward Focus: Eastern Alachua County,
                  a three-year initiative to enhance quality of life, boost
                  economic opportunities and address community needs in the
                  eastern part of the county. To kick off this important
                  project, a community input session will be held on Thursday,
                  Oct. 24th, from 6 to 8 p.m. at the Hawthorne Middle/High
                  School (21403 SE 69th Ave., Hawthorne). The session is open to
                  all residents, businesses, and local leaders, providing an
                  opportunity to share insights and ideas about the future of
                  eastern Alachua County. “We see incredible potential in
                  eastern Alachua County,” said Assistant County Manager Missy
                  Daniels. “This initiative is about unlocking that potential by
                  partnering with the community to create a brighter, more
                  prosperous future for everyone.” During this meeting, county
                  staff will outline the project’s goals and timeline. Attendees
                  will also have an opportunity to provide valuable feedback,
                  which will guide the creation of a community-wide survey
                  designed to capture the needs and aspirations of residents.
                </Typography>
              </AccordionDetails>
            </Accordion>
            {/* commented out the dynamic meetins data due to backend deployment issue. */}
            {/* {meetingsData ? (
              meetingsData[1].map((item) => (
                <Accordion
                  key={item.id}
                  expanded={expanded === item.id}
                  onChange={handleChange(item.id)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${item.id}-content`}
                    id={`panel${item.id}-header`}
                  >
                    <Typography>
                      <strong>Meeting Name : </strong>
                      {item.MeetingName}
                      <br />
                      <strong>Date & Time : </strong>
                      {item.DateTime}
                      <br />
                      <strong>Location : </strong>
                      {item.Location}
                    </Typography>{" "}
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2">
                      <strong>Description:</strong> {item.Description}
                    </Typography>
                    {item.Attachments.length > 0 ? (
                      <Typography variant="body2" sx={{ marginTop: 1 }}>
                        <strong>Attachments:</strong>
                        {item.Attachments.map((attachment, index) => (
                          <div key={index}>
                            <a
                              href={attachment[1]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {attachment[0]}
                            </a>
                          </div>
                        ))}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <p>Waiting for meetings data ...</p>
            )} */}
          </Grid>
        </Grid>
      </section>

      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}
